import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';

import {
	Dropdown, DropdownDisclosure, DropdownWrapper, useDropdownState
} from 'components/Dropdown';
import { utagLinkPDP } from 'features/tealium';

import { updateSortOrder } from '../reducers';

import './ProductReviewSort.scss';

const ProductReviewSort = ({ sortOptions }) => {

	const dispatch = useDispatch();
	const dropdown = useDropdownState(false);
	const { sortOrder } = useSelector((state) => state.productReviews);
	const activeSortOption = sortOptions.find((s) => s.value === sortOrder);
	const activeSortText = activeSortOption ? activeSortOption.text : sortOptions[0].text;

	const caretClasses = classNames('ProductReviewSort__toggleDropdownCaret', {
		'ProductReviewSort__toggleDropdownCaret--open': dropdown.show
	});

	function handleSortSelect (option) {

		// no need to update store if selected sort order is the same as previously selected
		if (sortOrder !== option.value) {

			dispatch(updateSortOrder(option.value));
			utagLinkPDP('TurnTo')({
				eventAction: 'Sort-Ratings-By',
				eventLabel: option.text
			});

		}

		dropdown.hideDropdown();

	}

	return (
		<>
			<div className="ProductReviewSort">
				<span className="ProductReviewSort__text">Sort by:</span>
				<DropdownWrapper>
					<DropdownDisclosure {...dropdown} className="ProductReviewSort__toggleDropdownBtn">
						<span className="ProductReviewSort__toggleDropdownBtnText">
							{activeSortText}
						</span>
						{' '}
						<span className={caretClasses} />
					</DropdownDisclosure>
					{dropdown.show && (
						<Dropdown {...dropdown}>
							<div className="ProductReviewSort__dropdownList">
								{sortOptions.map((option) => (
									<button
										key={option.value}
										type="button"
										onClick={() => handleSortSelect(option)}
										className={classNames('ProductReviewSort__dropdownListItem', {
											// eslint-disable-next-line max-len
											'ProductReviewSort__dropdownListItem--active': option.value === sortOrder
										})}
										aria-disabled={option.value === sortOrder}
									>
										{option.text}
									</button>
								))}
							</div>
						</Dropdown>
					)}
				</DropdownWrapper>
			</div>
		</>
	);

};

ProductReviewSort.propTypes = {
	sortOptions: PropTypes.arrayOf(
		PropTypes.shape({ text: PropTypes.string, value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number ]) })
	).isRequired
};

export default ProductReviewSort;
